namespace RecordShield.Workspace {
    export interface SerialKeyDetailsRow {
        ID?: number;
        SerialKey?: string;
        ProductId?: number;
        SerialKeyId?: number;
        Name?: string;
        Status?: Modules.Workspace.SerialKeys.KeyStatus;
        Code?: number;
        TenantName?: string;
        UserId?: number;
        Username?: string;
        DisplayName?: string;
        PublisherName?: string;
        Email?: string;
        Mobile?: string;
        FacultyEmail?: string;
        FacultyMobile?: number;
        Publisher?: number;
        SupportInfo?: string;
        ValidFrom?: string;
        ValidTo?: string;
        ActivationDate?: string;
        CreatedOn?: string;
        CurrentDeviceType?: string;
        ActivationDeviceType?: string;
        ActivationSysInfo?: string;
        Log?: string;
    }

    export namespace SerialKeyDetailsRow {
        export const idProperty = 'SerialKey';
        export const nameProperty = 'SerialKey';
        export const localTextPrefix = 'Workspace.SerialKeyDetails';

        export namespace Fields {
            export declare const ID: string;
            export declare const SerialKey: string;
            export declare const ProductId: string;
            export declare const SerialKeyId: string;
            export declare const Name: string;
            export declare const Status: string;
            export declare const Code: string;
            export declare const TenantName: string;
            export declare const UserId: string;
            export declare const Username: string;
            export declare const DisplayName: string;
            export declare const PublisherName: string;
            export declare const Email: string;
            export declare const Mobile: string;
            export declare const FacultyEmail: string;
            export declare const FacultyMobile: string;
            export declare const Publisher: string;
            export declare const SupportInfo: string;
            export declare const ValidFrom: string;
            export declare const ValidTo: string;
            export declare const ActivationDate: string;
            export declare const CreatedOn: string;
            export declare const CurrentDeviceType: string;
            export declare const ActivationDeviceType: string;
            export declare const ActivationSysInfo: string;
            export declare const Log: string;
        }

        ['ID', 'SerialKey', 'ProductId', 'SerialKeyId', 'Name', 'Status', 'Code', 'TenantName', 'UserId', 'Username', 'DisplayName', 'PublisherName', 'Email', 'Mobile', 'FacultyEmail', 'FacultyMobile', 'Publisher', 'SupportInfo', 'ValidFrom', 'ValidTo', 'ActivationDate', 'CreatedOn', 'CurrentDeviceType', 'ActivationDeviceType', 'ActivationSysInfo', 'Log'].forEach(x => (<any>Fields)[x] = x);
    }
}
